import type { ConstValues } from '@openx/types/helpers.ts';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

export const SENSITIVE_CATEGORIES_TABS = {
  Proposed: 'proposed',
  Applied: 'applied',
  Rejected: 'rejected',
} as const;

export type SensitiveCategoriesTabs = ConstValues<typeof SENSITIVE_CATEGORIES_TABS>;

const isTabValid = (tab: string): tab is SensitiveCategoriesTabs => {
  return Object.values(SENSITIVE_CATEGORIES_TABS).includes(tab as SensitiveCategoriesTabs);
};

const getTabFromPath = (pathname: string) => {
  const pathPart = pathname.split('/').pop() ?? '';

  return isTabValid(pathPart) ? pathPart : SENSITIVE_CATEGORIES_TABS.Proposed;
};

export const useSensitiveCategoriesTabs = (pathname: string) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<SensitiveCategoriesTabs>(getTabFromPath(pathname));

  useEffect(() => {
    const tabFromPath = getTabFromPath(pathname);

    if (tabFromPath !== activeTab) {
      setActiveTab(tabFromPath);
    }
  }, [activeTab, pathname]);

  const changeTab = (newTab: SensitiveCategoriesTabs) => {
    if (newTab === activeTab || !isTabValid(newTab)) {
      return;
    }
    setActiveTab(newTab);
    navigate(`/deals-sensitive-categories/${newTab}`);
  };

  return {
    activeTab,
    changeTab,
  };
};
